export default (payload = {}) => {
  return {
    primary_color: '#000',
    subdomain: '',
    logo_filename: '',
    top_title: '',
    top_subtitle: '',
    about_title: '',
    about_description: '',
    about_number_one: '',
    about_number_description_one: '',
    about_number_two: '',
    about_number_description_two: '',
    about_number_three: '',
    about_number_description_three: '',
    services_bookkeeping: true,
    services_trading_books: true,
    services_staff: true,
    recommendations_title: '',
    recommendations: [],
    teams: [],

    company: {},

    _logo_src: null,
    _logo_url: null,

    ...payload,
  };
}
